// src/hooks/products/useGetProductsForProgram.js
import { useQuery } from "@tanstack/react-query";
import { getAllProducts } from "../../api/apiProducts";
import i18next from "i18next";

/**
 * Hook to get products for program creation
 * Similar to useGetProducts but optimized for product selection
 */
const useGetProductsForProgram = (page = 1, perPage = 12, filters = {}) => {
    const { data, error, isLoading, refetch, isFetching } = useQuery({
        queryKey: ["products-for-program", page, perPage, filters, i18next.language],
        queryFn: () => getAllProducts(page, perPage, filters),
        keepPreviousData: true, // Keep previous data while fetching new
    });

    return {
        products: data?.data?.items || [],
        meta: data?.data?.meta || {},
        pagination: data?.data?.pagination || {},
        error,
        isLoading,
        isFetching,
        refetch,
    };
};

export default useGetProductsForProgram;
